import React from 'react';
import {hashHistory} from 'react-router';
import {DmsTab, DataList, RemarkModal, UploadFile} from 'Components';
import '../order/order.css';
import {Button, Table, Modal, Select, Input, Row, Col, Card, Progress} from 'antd';
import {fetchOrderDetail, returnConfirmation} from '../../service/returnGoods';
import {openNotice, config} from 'Utils';

class ReturnGoodsDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['退货详情'],
            orderDetail: {},
            isChangeReturnType: false,
            typeStatus: props.params.type == 'CUSTCHECK' || props.params.type == 'AFFIRM' || props.params.type == 'FILEUPLOAD' || props.params.type == 'CWCHECK' || props.params.type == 'COMFIRM' || props.params.type == 'CUSCONFIRM' || props.params.type == 'CLOSED' ? 1 : 2
        }
        this.returnRelatedTypesList = [
            {
                id: 'A',
                text: '未开票退换货处理',
                flag: true
            }, {
                id: 'B',
                text: '已开票-红字证明单',
                flag: false
            }, {
                id: 'D',
                text: '已开票-回购',
                flag: true
            }];
        this.goView = this.goView.bind(this);
    }

    goBack() {
        hashHistory.goBack();
    }

    componentDidMount() {
        const id = this.props.params.orderId;
        fetchOrderDetail({id}).then(res => {
            if (res && res.code === 200) {
                this.setState({
                    orderDetail: res.data
                });
                window.sessionStorage.setItem('returngoodsprint', JSON.stringify(res.data));
            }
        });

    }

    exportText() {
        var id = this.state.orderDetail.id;
        window.location.href = `${config.server}/api/v1/dms/dmsOrderGoback/ExportDetail/${id}`;
    }

    confirmation = () => {
        const {orderDetail} = this.state;
        returnConfirmation({
            qualityBusiness: orderDetail.qualityBusiness,
            erpHeadId: orderDetail.erpHeadId,
            returnType: orderDetail.returnType,
            returnTypeName: orderDetail.returnTypeName,
            id: orderDetail.id,
            status: 'CONFIRM',
        }).then(res => {
            if (res.code === 200) {
                openNotice('success', (res && res.message) ? res.message : '');
                this.goBack();
            } else {
                openNotice('error', (res && res.message) ? res.message : '');
            }
        });
    };

    confirmationSave = () => {
        const {orderDetail} = this.state;
        returnConfirmation({
            qualityBusiness: orderDetail.qualityBusiness,
            erpHeadId: orderDetail.erpHeadId,
            returnType: orderDetail.returnType,
            returnTypeName: orderDetail.returnTypeName,
            id: orderDetail.id,
            status: 'SAVE',
        }).then(res => {
            if (res.code === 200) {
                openNotice('success', (res && res.message) ? res.message : '');
                this.goBack();
            } else {
                openNotice('error', (res && res.message) ? res.message : '');
            }
        });
    };
    confirmationDorp = () => {
        const {orderDetail} = this.state;
        returnConfirmation({
            qualityBusiness: orderDetail.qualityBusiness,
            erpHeadId: orderDetail.erpHeadId,
            id: orderDetail.id,
            status: 'CANCEL',
        }).then(res => {
            if (res.code === 200) {
                openNotice('success', (res && res.message) ? res.message : '');
                this.goBack();
            } else {
                openNotice('error', (res && res.message) ? res.message : '');
            }
        });
    };
    confirmationGoUp = () => {
        const {orderDetail} = this.state;
        returnConfirmation({
            qualityBusiness: orderDetail.qualityBusiness,
            erpHeadId: orderDetail.erpHeadId,
            id: orderDetail.id,
            status: 'REFUSE',
        }).then(res => {
            if (res.code === 200) {
                openNotice('success', (res && res.message) ? res.message : '');
                this.goBack();
            } else {
                openNotice('error', (res && res.message) ? res.message : '');
            }
        });
    };

    goView(url) {
        hashHistory.push(url);
    };

    returnGooodsPrint() {
        window.open('/pcweb/#/returnGoodsPrint')
        // window.open('/#/returnGoodsPrint')
    }

    returnGooodsPrint2() {
        window.open('/pcweb/#/buyReturnPrint')
        // window.open('/#/buyReturnPrint')
    }

    returnGooodsPrint3() {
        window.open('/pcweb/#/returnOutstorckPrint')
        // window.open('/#/buyReturnPrint')
    }

    changeSelect(value) {
        this.returnRelatedTypesList.map(item => {
            if (item.id == value) {
                this.setState({
                    returnType: value,
                    isChangeReturnType: true,
                    orderDetail: {...this.state.orderDetail, returnType: value, returnTypeName: item.text}
                });
            }
        })
    }

    render() {
        const {opts, orderDetail, returnRelatedTypesList, isChangeReturnType} = this.state;
        const tableViewProps = {
            rowKey: 'id',
            scroll: {x: 1500, y: false},
            columns: [{
                title: '序号',
                dataIndex: 'id',
                render: (text, record, index) => {
                    return index + 1;
                }
            }, {
                title: '渠道',
                dataIndex: 'channelName'
            }, {
                title: '产品线',
                dataIndex: 'productLineName'
            }, {
                title: '物料编码',
                dataIndex: 'objCode',
                width: '9%'
            }, {
                title: '物料描述',
                dataIndex: 'objDescription'
            }, {
                title: '生产公司',
                dataIndex: 'factoryName'
            }, {
                title: '属性',
                dataIndex: 'property'
            }, {
                title: '库存分类',
                dataIndex: 'secondStockType'
            }, {
                title: '单位',
                dataIndex: 'unit'
            }, {
                title: '牌价',
                dataIndex: 'brandPrice',
                width: 90
            }, {
                title: '销售单价',
                dataIndex: 'sellPrice',
                width: 100
            }, {
                title: '退货数量',
                dataIndex: 'gobackCount'
            }, {
                title: '实收数量',
                dataIndex: 'realQuantity'
            }, {
                title: '退货扣点',
                dataIndex: 'refunds'
            }, {
                title: '扣点金额',
                dataIndex: 'refunds1',
                width: 80,
                render: (text, record, index) => {
                    if (record.sellMoney && record.refunds) {
                        return <div>{(record.sellMoney * (record.refunds / 100)).toFixed(2) || 0}</div>
                    } else {
                        return <span>{''}</span>
                    }
                }
            }, {
                title: '处理意见',
                dataIndex: 'processExplain'
            }, {
                title: '销售金额',
                dataIndex: 'sellMoney',
                width: 100,
                render: (text, record, index) => {
                    if (record.realQuantity && record.realQuantity != '' && record.realQuantity != 'undefined') {
                        return <div>{(record.realQuantity * record.sellPrice).toFixed(4) || 0}</div>
                    } else {
                        return <div>{(record.gobackCount * record.sellPrice).toFixed(4) || 0}</div>
                    }
                }
            }, {
                title: '原出库单号',
                dataIndex: 'stockCode',
                width: 100
            }, {
                title: '原订单号',
                dataIndex: 'orderCode',
                width: 100
            }, {
                title: '原订单折扣率',
                dataIndex: 'discount'
            }, {
                title: '折扣后单价',
                dataIndex: 'discountPrice'
            }, {
                title: '折扣后金额',
                dataIndex: 'discountMoney',
                render: (text, record, index) => {
                    if (record.realQuantity && record.realQuantity != '' && record.realQuantity != 'undefined') {
                        return <div>{(record.realQuantity * record.discountPrice).toFixed(4) || 0}</div>
                    } else {
                        return <div>{(record.gobackCount * record.discountPrice).toFixed(4) || 0}</div>
                    }
                }
            }, {
                title: '税率',
                dataIndex: 'taxCode'
            }, {
                title: '问题描述/备注',
                dataIndex: 'questionDescription',
                render: (text, record, index) => {

                    if (record.questionDescription) {
                        return record.questionDescription;
                    } else {
                        return record.remark;
                    }

                }
            }, {
                title: '是否取消',
                dataIndex: 'status',
                render: (text, record, index) => {

                    if (record.status == 'Y') {
                        return '是';
                    } else {
                        return "否";
                    }

                }
            }],
            dataSource: this.state.orderDetail.lineList || []
        };
        let orderRecordHtml = (orderDetail.recordList || []).map(function (qst, key) {
            if (qst.promissMsg == "异常") {
                return <a className="already" key={key}>
                    <Progress className="index" type="circle" percent={70} format={() => key + 1} width={50}
                              status="exception"></Progress>
                    <p className="f">{qst.userName}</p>
                    <p className="f" style={{height: 33}}>{qst.message}</p>
                    <p className="f" style={{height: 33}}>{qst.promissMsg}</p>
                    <p
                        className={qst.createdDate ? '' : 'no'}>{new Date(qst.createdDate).format('yyyy-MM-dd hh:mm:ss') || '-'}</p>
                    <span style={{display: key == (orderDetail.recordList.length - 1) ? 'none' : 'inline-block'}}
                          className="l"></span>
                </a>
            }
            return <a className="already" key={key}>
                <Progress className="index" type="circle" percent={100} format={() => key + 1} width={50}></Progress>
                <p className="f">{qst.userName}</p>
                <p className="f" style={{height: 33}}>{qst.message}</p>
                <p className="f" style={{height: 33}}>{qst.promissMsg}</p>
                <p
                    className={qst.createdDate ? '' : 'no'}>{new Date(qst.createdDate).format('yyyy-MM-dd hh:mm:ss') || '-'}</p>
                <span style={{display: key == (orderDetail.recordList.length - 1) ? 'none' : 'inline-block'}}
                      className="l"></span>
            </a>
        });
        return (
            <div className="dms-main-box">
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button onClick={this.returnGooodsPrint3.bind(this)}
                                style={{display: (orderDetail.nextStatus == '提交') ? 'none' : 'block', float: 'left'}}
                        >退货单</Button>
                        <Button onClick={this.returnGooodsPrint2.bind(this)}
                                style={{display: (this.state.typeStatus == 1) ? 'block' : 'none', float: 'left'}}
                        >回购协议</Button>
                        <Button onClick={this.returnGooodsPrint.bind(this)}
                                style={{display: (this.state.typeStatus == 1) ? 'block' : 'none', float: 'left'}}
                        >回执单</Button>
                        {
                            isChangeReturnType ? <Button onClick={this.confirmationSave}>保存</Button> : null
                        }
                        {
                            orderDetail.confirm ? <Button onClick={this.confirmation}>退货确认</Button> : null
                        }
                        {
                            orderDetail.confirm ? <Button onClick={this.confirmationDorp}>取消退货</Button> : null
                        }
                        {
                            orderDetail.confirm ? <Button onClick={this.confirmationGoUp}>驳回上一步
                            </Button> : null
                        }
                        <Button onClick={this.goBack}>返回</Button>
                        <Button onClick={this.exportText.bind(this)}>导出</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <div>
                            <Row>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>退货编号：</label>
                                            <span>{orderDetail.orderNumber}</span></p>
                                        <p><label>客户名称：</label>
                                            <span>{orderDetail.cusName}</span></p>
                                        <p><label>客户编号：</label>
                                            <span>{orderDetail.cusNumber}</span></p>
                                        <p><label>退货日期：</label>
                                            <span>{orderDetail.returnDate}</span></p>
                                        <p><label>退货类型：</label>
                                            <span>{orderDetail.qualityBusiness == 'Q' ? '质量退货' : orderDetail.qualityBusiness == 'B' ? '商务退货' : '-'}</span>
                                        </p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>购货单位：</label>
                                            <span>{orderDetail.purchaseName}</span></p>
                                        <p><label>签约类型：</label>
                                            <span>{orderDetail.contractType}</span></p>
                                        <p><label>税率：</label>
                                            <span>{orderDetail.taxCode}</span></p>
                                        <p><label>退货相关类型：</label>
                                            {/*<span>{orderDetail.returnTypeName}</span>*/}
                                            <Select value={orderDetail.returnType}
                                                    style={{width: '154px'}}
                                                    disabled={(orderDetail.confirm != true && orderDetail.status != '客户已确认') || orderDetail.returnType == 'A'}
                                                    onChange={(value) => {
                                                        this.changeSelect(value)
                                                    }}>
                                                {this.returnRelatedTypesList.map(item => <Select.Option key={item.id}
                                                                                                        value={item.id}
                                                                                                        disabled={item.flag}>{item.text}</Select.Option>)}
                                            </Select></p>
                                        <p><label>退货细分类型：</label>
                                            <span>{orderDetail.returnDetailType}</span></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>退货地点：</label>
                                            <span>{orderDetail.gobackAddress || '-'}</span></p>
                                        <p><label>退货子库：</label>
                                            <span>{orderDetail.gobackStockeName || '-'}</span></p>
                                        <p><label>联系电话：</label>
                                            <span>{orderDetail.phone || '-'}</span></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>年度销售总额：</label>
                                            <span>{orderDetail.yearArturnAmount || '-'}</span></p>
                                        <p><label>年度退货总额：</label>
                                            <span>{orderDetail.yearGobackAmount || '-'}</span></p>
                                        <p><label>本次退货金额：</label>
                                            <span>{orderDetail.curArturnAmount || '-'}</span></p>
                                        <p><label>实际退货金额：</label>
                                            <span>{orderDetail.actualReturnAmount || '-'}</span></p>
                                    </Card>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={24}>
                                    <label style={{paddingLeft: '24px'}}>OA流程编号：</label>
                                    <span>{orderDetail.oaProcess || '-'}</span>
                                    <label style={{paddingLeft: '20px'}}>审批日期：</label>
                                    <span>{orderDetail.orderDate == null ? "-" : new Date(orderDetail.orderDate).format('yyyy-MM-dd')}</span>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={24}>
                                    <label style={{paddingLeft: '24px'}}>退单反馈信息：</label>
                                    <span>{orderDetail.feedback || '-'}</span>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <DmsTab className="white-bg no-border" options={['退货物料']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <Table {...tableViewProps} bordered/>
                            </div>
                        </div>
                        <div>
                            <DmsTab className="white-bg no-border" options={['审批信息']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <div className="order_detail">
                                    <div className="opt">
                                        {orderRecordHtml}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReturnGoodsDetail;



// WEBPACK FOOTER //
// ./src/routes/returnGoods/detail.js